import { saveAs } from 'file-saver';

export class BlobLink {
    static download(blob: Blob, filename: string) {
        saveAs(blob, filename);
    }
}
